/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacypolicy1Inputs */

const en_privacypolicy1 = /** @type {(inputs: Privacypolicy1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Privacy Policy`)
};

const de_privacypolicy1 = /** @type {(inputs: Privacypolicy1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Datenschutzrichtlinie`)
};

/**
* | output |
* | --- |
* | "Privacy Policy" |
*
* @param {Privacypolicy1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const privacypolicy1 = /** @type {((inputs?: Privacypolicy1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacypolicy1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_privacypolicy1(inputs)
	return de_privacypolicy1(inputs)
});
export { privacypolicy1 as "privacyPolicy" }